import { Badge } from "components/Badge/Badge";
import {
  getBadgeColor,
  getIcon,
} from "page-components/Library/CreateFolder/themeOptions";
import { Folder } from "page-components/Library/FolderPage/ThreeDotsMenu/FolderType";
import styles from "./BreadcrumbFolder.module.css";
import { useSessionWithUser } from "gui/session/session";
import { ClickPopover } from "components/ClickPopover";
import { MoveToFolder } from "page-components/Library/MoveContentIndividually/MoveToFolder";

interface Props {
  content: {
    type: "dashboard" | "query";
    id?: number;
  };
  result?: Folder;
  refetch?: () => Promise<void> | void;
}
export function BreadcrumbFolder(props: Props) {
  const {
    content: { type, id },
    result: folder,
    refetch,
  } = props;
  const session = useSessionWithUser();

  if (!session || !folder || id === undefined) {
    return null;
  }

  if (folder.name === "Archived") {
    return (
      <div className={styles.folder}>
        <Badge
          size="L"
          variant="filled"
          color={getBadgeColor(folder.color)}
          iconOnly
        >
          {getIcon(folder.icon)}
        </Badge>
        <div>{folder.name}</div>
      </div>
    );
  }

  return (
    <div className={styles.folder}>
      <ClickPopover
        content={() => (
          <MoveToFolder
            session={session}
            currentFolderName={folder.name}
            isCreations={folder.name === "Creations"}
            contentItem={{
              type: type,
              id: id,
            }}
            refetch={refetch}
          />
        )}
        position="below-align-left"
        closeOnClickOutside={true}
      >
        <button>
          <Badge
            size="L"
            variant="filled"
            color={getBadgeColor(folder.color)}
            iconOnly
          >
            {getIcon(folder.icon)}
          </Badge>
        </button>
      </ClickPopover>
      <div>{folder.name === "" ? "Creations" : folder.name}</div>
    </div>
  );
}
